module.exports = __webpack_public_path__ + "static/img/tigerLogo.f8daf954.png";